import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getProductionDepartments({ commit }) {
        return axios
            .get('/production-departments/dicts/production-departments?showInInternalComplaint=true')
            .then(response => {
                const departments = [...(response.data.results || [])].sort((a, b) =>
                    (a.name || '').localeCompare(b.name || '', 'pl')
                )

                commit('GET_PRODUCTION_DEPARTMENTS_SUCCESS', departments)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie działów nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getProductionSiteGroups({ commit }, productionDepartment) {
        return axios
            .get(`/production-sites/production-site-groups?productionDepartment_id=${productionDepartment}`)
            .then(response => {
                commit('GET_PRODUCTION_SITE_GROUPS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie grup stanowisk nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getProductionProcesses({ commit }, query = {}) {
        const params = query.productionSiteGroupId
            ? `productionSiteGroupId=${query.productionSiteGroupId}`
            : `departmentId=${query.complaintProductionDepartmentId}`

        return axios
            .get(`/production-processes/processes-raw?${params}`)
            .then(response => {
                commit('GET_PRODUCTION_PROCESSES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie procesów produkcyjnych nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getMachines({ commit }, productionSiteGroupId) {
        return axios
            .get(`/machines/machines-raw?productionSiteGroupId=${productionSiteGroupId}`)
            .then(response => {
                commit('GET_MACHINES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie maszyn nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getReportItems({ commit }, searchNumber) {
        return axios
            .get(`/reports/report-items?primaryNumber=${searchNumber}&typeId=10,70&limit=15`)
            .then(response => {
                commit('GET_REPORT_ITEMS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wyszukiwanie zleceń nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getUsers({ commit }, data) {
        return axios
            .get(`/users/users?search=${data.search}`)
            .then(response => {
                if (data.type === 'users') {
                    commit('GET_USERS_SUCCESS', response.data.results)
                }

                if (data.type === 'responsibleUsers') {
                    commit('GET_RESPONSIBLE_USERS_SUCCESS', response.data.results)
                }

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy użytkowników nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getErrorCodeGroups({ commit }) {
        return axios
            .get('/complaints/complaints/dicts/error-code-groups')
            .then(response => {
                commit('GET_ERROR_CODE_GROUPS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie grup kodów błędu nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getProceedingWays({ commit }) {
        return axios
            .get('/complaints/complaints/dicts/complaint-way-of-proceeding')
            .then(response => {
                commit('GET_PROCEEDING_WAYS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie sposobów postępowania nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getStatuses({commit}) {
        return axios
            .get('/complaints/complaints/dicts/statuses?availableAtInternalComplaint=true')
            .then(response => {
                commit('GET_STATUSES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
}
